import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import { bindActionCreators } from 'redux';
import * as classroomGroupActions from '../../../actions/classroom/classroomGroupActions';
import * as messageAlert from '../../../actions/messageAlertAction';
import { GROUPS, PICTOGRAM_CONFIG } from '../../../const';
import { Modal, Button, Paragraph } from '@netexknowledge/smart-components';
import CheckBoxContainer from '../../library/CheckboxContainer';

class PictogramConfigReveal extends React.Component {
  constructor(context, props) {
    super(context, props);
    this.closeModal = this.closeModal.bind(this);
    this.handlePictogramConfigClassroom = this.handlePictogramConfigClassroom.bind(this);
    this.onCheckText = this.onCheckText.bind(this);
    this.onCheckImage = this.onCheckImage.bind(this);
    this.onCheckTextImage = this.onCheckTextImage.bind(this);
    this.setChecks = this.setChecks.bind(this);
  }

  static propTypes = {
    group: PropTypes.object,
    classroomGroupActions: PropTypes.object,
    messageAlert: PropTypes.object,
    colors: PropTypes.object
  };

  state = {
    checkText: false,
    checkImage: false,
    checkTextImage: false
  };

  setChecks() {
    const { group } = this.props;
    if (group) {
      this.setState({
        checkText: this.props.group ? this.props.group.pictogramConfig === PICTOGRAM_CONFIG.TEXT : false,
        checkImage: this.props.group ? this.props.group.pictogramConfig === PICTOGRAM_CONFIG.IMAGE : false,
        checkTextImage: this.props.group ? this.props.group.pictogramConfig === PICTOGRAM_CONFIG.TEXT_IMAGE : false
      });
    }
  }

  closeModal() {
    const { classroomGroupActions } = this.props;
    classroomGroupActions.setPictogramConfig();
  }

  onCheckText() {
    const { group } = this.props;
    if (group) {
      group.pictogramConfig = PICTOGRAM_CONFIG.TEXT;
      this.setState({
        checkText: true,
        checkImage: false,
        checkTextImage: false
      });
    }
  }

  onCheckImage() {
    const { group } = this.props;
    if (group) {
      group.pictogramConfig = PICTOGRAM_CONFIG.IMAGE;
      this.setState({
        checkText: false,
        checkImage: true,
        checkTextImage: false
      });
    }
  }

  onCheckTextImage() {
    const { group } = this.props;
    if (group) {
      group.pictogramConfig = PICTOGRAM_CONFIG.TEXT_IMAGE;
      this.setState({
        checkText: false,
        checkImage: false,
        checkTextImage: true
      });
    }
  }

  getPictogramConfig() {
    const { checkText, checkImage, checkTextImage } = this.state;
    return checkText
      ? PICTOGRAM_CONFIG.TEXT
      : checkImage
      ? PICTOGRAM_CONFIG.IMAGE
      : checkTextImage
      ? PICTOGRAM_CONFIG.TEXT_IMAGE
      : null;
  }

  handlePictogramConfigClassroom() {
    const { classroomGroupActions, group, messageAlert } = this.props;
    this.closeModal();
    classroomGroupActions.setPictogramConfigGroup(group.id, this.getPictogramConfig()).then(() => {
      classroomGroupActions.setSelectedGroup(GROUPS.EVERYONE);
      messageAlert.success(I18n.t('pictogramConfigGroupPopup.configSuccess'));
    });
    this.setState({
      checkText: false,
      checkImage: false,
      checkTextImage: false
    });
  }

  render() {
    const { group } = this.props;
    const { checkText, checkImage, checkTextImage } = this.state;
    if (!checkText && !checkImage && !checkTextImage) {
      this.setChecks();
    }

    return (
      <Modal
        id="pictogram-config"
        title={I18n.t('pictogramConfigGroupPopup.pictogramConfigGroup')}
        active={!!group}
        onClickOutside={this.closeModal}
        footer={
          <>
            <Button onClick={this.closeModal} label={I18n.t('common.cancel')}></Button>
            <Button onClick={this.handlePictogramConfigClassroom} primary label={I18n.t('common.option.save')}></Button>
          </>
        }
      >
        <>
          <Paragraph className="text-grey-700">
            {I18n.t('pictogramConfigGroupPopup.pictogramConfigGroupDisclaimer')}
          </Paragraph>
          <CheckBoxContainer
            checked={checkText}
            checkId={I18n.t('pictogramConfigGroupPopup.text')}
            onCheck={this.onCheckText}
          />
          <CheckBoxContainer
            checkId={I18n.t('pictogramConfigGroupPopup.image')}
            checked={checkImage}
            onCheck={this.onCheckImage}
          />
          <CheckBoxContainer
            checkId={I18n.t('pictogramConfigGroupPopup.textImage')}
            checked={checkTextImage}
            onCheck={this.onCheckTextImage}
          />
        </>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    group: state.group.pictogramConfigGroup,
    i18n: state.i18n,
    colors: state.theme.colors
  };
}

function mapDispatchToProps(dispatch) {
  return {
    classroomGroupActions: bindActionCreators(classroomGroupActions, dispatch),
    messageAlert: bindActionCreators(messageAlert, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PictogramConfigReveal);
